Ext.define('WindowProject', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.projekt.capitalise(),
    width: 700,
    height: 785,
    closable: false,
    collapsible: false,
    modal: true,
    scrollable: true,
    resizable: false,
    layout: 'fit',
    showOnlyRaport: false,
    initComponent: function (config) {
        this.cid = Ext.id();
        let formpanel = {
            id: this.cid + "formpanel",
            title: Lang.ogolne.capitalise(),
            xtype: 'form',
            disabled: this.showOnlyRaport,
            frame: true,
            border: false,
            scrollable: true,
            autoWidth: true,
            autoHeight: true,
            height: 535,
            labelWidth: 80,
            bodyStyle: 'padding:10px 10px 10px 10px',
            defaults: {
                anchor: "0",
                labelWidth: 80
            },
            fileUpload: true,
            items: [{
                anchor: "0",
                layout: 'column',
                frame: false,
                border: false,
                items: [{
                    columnWidth: 1,
                    layout: 'anchor',
                    frame: false,
                    border: false,
                    labelWidth: 200,
                    defaults: {
                        anchor: "0",
                        labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left',
                        labelWidth: 140
                    },
                    items: [{
                        id: this.cid + "nazwa",
                        name: "nazwa",
                        xtype: 'textfieldexd',
                        regex: new RegExp(Const.PROJECTNAMEREGEX),
                        invalidText: Lang.dane_niepoprawne,
                        fieldLabel: Const.ENABLEKELLER ? Lang.nazwa_projektu : Lang.nazwa,
                        allowBlank: false,
                        maxLength: 64,
                        blankText: Lang.pole_nie_moze_byc_puste,
                        afterSubTpl: Const.ENABLEKELLER
                            ? '<div style="color: gray; font-size: 12px; margin-top: 4px; margin-bottom: 8px;">' + Lang.przyklad + ': S/265/210025-1</div>'
                            : null
                    }, {
                        id: this.cid + "czasotwarcia",
                        name: "czasotwarcia",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.czas_otwarcia,
                        editable: false,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "czaszamkniecia",
                        name: "czaszamkniecia",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.czas_zamkniecia,
                        editable: false,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "operator",
                        name: "operator",
                        fieldLabel: Const.ENABLEKELLER ? Lang.nadzor_budowy : Lang.operator,
                        allowBlank: false,
                        xtype: "comboexd",
                        minChars: 1,
                        editable: true,
                        store: Ext.create('Ext.data.Store', {
                            fields: ['id', 'imie', 'nazwisko', {
                                name: 'nazwa',
                                convert: function(value, record) {
                                    return record.get('imie') + ' ' + record.get('nazwisko');
                                }
                            }],
                            proxy: {
                                type: 'ajax',
                                url: 'rest/operators/getList',
                                actionMethods: {
                                    read: 'POST'
                                },
                                reader: new Ext.data.JsonReader({
                                    id: "id",
                                    rootProperty: ''
                                }, [{
                                    name: 'imie',
                                    mapping: 'imie'
                                }, {
                                    name: 'nazwisko',
                                    mapping: 'nazwisko'
                                }])
                            },
                            autoLoad: false,
                            listeners: {
                                load: function(store) {
                                    if (Const.ENABLEKELLER) {
                                        store.filterBy(function(record) {
                                            return record.get('hpoziom') < 9;
                                        });
                                    }
                                }
                            }
                        }),
                        displayField: 'nazwa',
                        valueField: 'id',
                        forceSelection: true,
                        emptyText: '...'
                    }]
                }]
            }]
        };
        this.items = [{
            xtype: 'tabpanel',
            autoWidth: true,
            autoHeight: true,
            border: false,
            deferredRender: false,
            activeTab: this.showOnlyRaport? 2 : 0,
            items: [formpanel, {
                title: Lang.zbiorniki.capitalise(),
                id: this.cid + "formpanel2",
                hidden: false,
                xtype: "panel",
                disabled: this.showOnlyRaport,
                layout: "fit",
                frame: true,
                autoWidth: true,
                labelAlign: "top",
                bodyStyle: 'padding:10px 10px 10px 10px',
                items: [{
                    xtype: 'panel',
                    frame: false,
                    border: false,
                    autoWidth: true,
                    layout: 'hbox',
                    layoutConfig: {
                        align: "stretch"
                    },
                    items: [new Ext.ux.grid.GridPanelExd({
                        store: new Ext.data.Store({
                            autoLoad: false,
                            proxy: {
                                type: "ajax",
                                url: "rest/zbiorniki/getList",
                                actionMethods: {
                                    read: 'GET'
                                },
                                reader: new Ext.data.JsonReader({
                                    id: "id",
                                    rootProperty: ''
                                }, [{
                                    name: 'nazwa',
                                    mapping: 'nazwa'
                                }])
                            }
                        }),
                        columns: [{
                            header: Lang.nazwa,
                            flex: 1,
                            width: 145,
                            sortable: true,
                            dataIndex: 'nazwa'
                        }],
                        title: Lang.dostepne.capitalise(),
                        height: 390,
                        flex: 1,
                        frame: true,
                        border: true,
                        id: this.cid + "zbiorniks_from",
                        stateId: null,
                        stateful: false,
                        stripeRows: true,
                        enableHdMenu: true,
                        selModel: {
                            selType: 'rowmodel',
                            mode: 'SINGLE'
                        },
                        listeners: {
                            scope: this,
                            rowdblclick: function () {
                                var grid = Ext.getCmp(this.cid + "zbiorniks_from");
                                var grid2 = Ext.getCmp(this.cid + "zbiorniks_to");
                                var r = grid.getSelR();
                                if (r == null || r.items.length == 0)
                                    return;
                                var selectedItem = r.items[0];
                                grid.store.remove(selectedItem);
                                grid2.store.add(selectedItem);
                            }
                        },
                        getSelR: function () {
                            var gridd = this;
                            if (!gridd.getSelectionModel().hasSelection()) {
                                return null;
                            } else {
                                if (gridd.getSelectionModel().getSelected() != null) {
                                    return gridd.getSelectionModel().getSelected();
                                }
                            }
                            return null;
                        }
                    }), {
                        width: 55,
                        xtype: 'panel',
                        frame: false,
                        border: false,
                        bodyStyle: 'padding:5px 5px 5px 5px',
                        height: 390,
                        layout: {
                            type: 'vbox',
                            pack: "center",
                            align: "stretch"
                        },
                        items: [{
                            xtype: 'button',
                            text: ">",
                            width: 50,
                            scope: this,
                            style: "margin-bottom:5px;",
                            handler: function () {
                                var grid = Ext.getCmp(this.cid + "zbiorniks_from");
                                var grid2 = Ext.getCmp(this.cid + "zbiorniks_to");
                                var r = grid.getSelR();
                                if (r == null || r.items.length == 0)
                                    return;
                                var selectedItem = r.items[0];
                                grid.store.remove(selectedItem);
                                grid2.store.add(selectedItem);
                            }
                        }, {
                            xtype: 'button',
                            text: ">>",
                            width: 50,
                            scope: this,
                            style: "margin-bottom:5px;",
                            handler: function () {
                                var grid = Ext.getCmp(this.cid + "zbiorniks_from");
                                var grid2 = Ext.getCmp(this.cid + "zbiorniks_to");
                                grid2.store.add(grid.store.getRange());
                                grid.store.removeAll();
                            }
                        }, {
                            xtype: 'button',
                            text: "<",
                            width: 50,
                            scope: this,
                            style: "margin-bottom:5px;",
                            handler: function () {
                                var grid = Ext.getCmp(this.cid + "zbiorniks_from");
                                var grid2 = Ext.getCmp(this.cid + "zbiorniks_to");
                                var r = grid2.getSelR();
                                if (r == null || r.items.length == 0)
                                    return;
                                var selectedItem = r.items[0];
                                grid2.store.remove(selectedItem);
                                grid.store.add(selectedItem);
                            }
                        }, {
                            xtype: 'button',
                            text: "<<",
                            width: 50,
                            scope: this,
                            style: "margin-bottom:5px;",
                            handler: function () {
                                var grid = Ext.getCmp(this.cid + "zbiorniks_from");
                                var grid2 = Ext.getCmp(this.cid + "zbiorniks_to");
                                grid.store.add(grid2.store.getRange());
                                grid2.store.removeAll();
                            }
                        }]
                    }, new Ext.ux.grid.GridPanelExd({
                        store: new Ext.data.Store({
                            autoLoad: false,
                            proxy: new Ext.data.MemoryProxy({}),
                            reader: new Ext.data.JsonReader({
                                id: "id",
                                rootProperty: ''
                            }, [{
                                name: 'nazwa',
                                mapping: 'nazwa'
                            }])
                        }),
                        columns: [{
                            header: Lang.nazwa,
                            flex: 1,
                            width: 145,
                            sortable: true,
                            dataIndex: 'nazwa'
                        }],
                        title: Lang.wybrane.capitalise(),
                        height: 390,
                        flex: 1,
                        frame: true,
                        border: true,
                        id: this.cid + "zbiorniks_to",
                        stateId: null,
                        stateful: false,
                        stripeRows: true,
                        enableHdMenu: true,
                        selModel: {
                            selType: 'rowmodel',
                            mode: 'SINGLE'
                        },
                        listeners: {
                            scope: this,
                            rowdblclick: function () {
                                var grid = Ext.getCmp(this.cid + "zbiorniks_from");
                                var grid2 = Ext.getCmp(this.cid + "zbiorniks_to");
                                var r = grid2.getSelR();
                                if (r == null || r.items.length == 0)
                                    return;
                                var selectedItem = r.items[0];
                                grid2.store.remove(selectedItem);
                                grid.store.add(selectedItem);
                            }
                        },
                        getSelR: function () {
                            var gridd = this;
                            if (!gridd.getSelectionModel().hasSelection()) {
                                return null;
                            } else {
                                if (gridd.getSelectionModel().getSelected() != null) {
                                    return gridd.getSelectionModel().getSelected();
                                }
                            }
                            return null;
                        }
                    })]
                }]
            }, {
                id: this.cid + "formpanel4",
                title: Lang.raport,
                xtype: 'form',
                frame: true,
                border: false,
                autoWidth: true,
                scrollable: true,
                autoHeight: true,
                height: 535,
                labelWidth: 80,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0",
                    labelWidth: 80
                },
                items: [{
                    region: "north",
                    xtype: 'toolbar',
                    items: [{
                        xtype: 'button',
                        iconAlign: 'left',
                        iconCls: "iconPDF",
                        style: 'margin: 5px; border: 0.5px #d9d9d9 solid',
                        text: Lang.pdf.capitalise(),
                        scope: this,
                        handler: this.getDownloadLsPdf
                    }]
                }, {
                    xtype: 'panel',
                    items: [{
                        id: this.cid + "raport",

                        xtype: 'box',
                        border: true,
                        frame: true,
                        width: '100%',
                        cls: 'project-panel-raport',
                        height: '100%',
                        html: ''
                    }]
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            scope: this,
            hidden: this.showOnlyRaport,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        if (!validPrivilegesOperatorComplex("access.manage.projects") && !validPrivilegesOperatorComplex("access.advmanage.projects") && !this.showOnlyRaport) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.obiektid = obiektid;
        this.obiekt = null;
        performAjaxLPromise('rest/zbiorniki/getList', {
            unassignedToProject: Const.ENABLEPROJECTS,
            alreadyAssignedProjectId: this.obiektid
        }).then(data => {
            let listFnData0 = data;
            performAjaxLPromise("rest/projects/getObjectForEdit", {
                id: this.obiektid
            }).then(data => {
                this.obiekt = data;
                this.show();
                this.center();
                this.setKeyMap({
                    'ESC': {
                        scope: this,
                        handler: this.closeOp
                    }
                });
                var operatorStore = Ext.getCmp(this.cid + "operator").getStore();
                operatorStore.load();
                let grid = Ext.getCmp(this.cid + "zbiorniks_from");
                let grid2 = Ext.getCmp(this.cid + "zbiorniks_to");
                Ext.getCmp(this.cid + "nazwa").setValue(null);
                Ext.getCmp(this.cid + "nazwa").clearInvalid();
                Ext.getCmp(this.cid + "czasotwarcia").setValue(null);
                Ext.getCmp(this.cid + "czasotwarcia").clearInvalid();
                Ext.getCmp(this.cid + "czaszamkniecia").setValue(null);
                Ext.getCmp(this.cid + "czaszamkniecia").clearInvalid();
                Ext.getCmp(this.cid + "operator").setValue(null);
                if (this.obiekt) {
                    let obss = generateDiffCollection(listFnData0, this.obiekt.zbiorniki, "id");
                    grid.store.loadData(obss.restls);
                    grid2.store.loadData(obss.containsls);
                    Ext.getCmp(this.cid + "nazwa").setValue(this.obiekt.nazwa);
                    Ext.getCmp(this.cid + "czasotwarcia").setValue(this.obiekt.czasotwarcia);
                    Ext.getCmp(this.cid + "czaszamkniecia").setValue(this.obiekt.czaszamkniecia);
                    Ext.getCmp(this.cid + "operator").setValue(this.obiekt.idoperator);
                    Ext.getCmp(this.cid + "operator").valueNotFoundText = this.obiekt.operator;
                    Ext.getCmp(this.cid + "raport").update(this.obiekt.raport);
                } else {
                    Ext.getCmp(this.cid + "formpanel4").setDisabled(true)
                    grid.store.loadData(listFnData0);
                    grid2.store.loadData([]);
                    Ext.getCmp(this.cid + "operator").setValue(AppOPERATOR.id);
                }
            }).catch(err => {
                Ext.MessageBox.alert(Lang.error, err);
            });
        }).catch(err => {
            Ext.MessageBox.alert(Lang.error, err);
        });

    },
    saveOp: function () {
        var canWrite = false;
        if (Ext.getCmp(this.cid + "nazwa").isValid()) {
            canWrite = true;
        }
        if (canWrite) {
            let grid2 = Ext.getCmp(this.cid + "zbiorniks_to");
            zbiorniki = grid2.store.collect('id');
            let operator = Ext.getCmp(this.cid + "operator").getValue2NL();
            sendAjaxDataJsonRpcL("rest/projects/saveObject", {
                id: this.obiektid,
                nazwa: Ext.getCmp(this.cid + "nazwa").getValue(),
                zbiorniki: zbiorniki,
                operator: operator
            }, this, function (data) {
                if (data.status) {
                    data = data.data;
                    this.obiektid = data.id;
                    this.close();
                } else {
                    Ext.MessageBox.alert(Lang.error, data.error);
                }
                if (this.callbackF)
                    this.callbackF();
            });
        } else {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
        }
    },
    getDownloadLsPdf: function () {
        postFormAsync("rest/projects/downloadPdfRaport", {
            id: this.obiektid
        }, null);
    },
    closeOp: function () {
        this.close();
    }
});
